// import React from "react";
// import { Box, Typography, Tooltip, IconButton } from "@mui/material";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// const ItemCard = ({ index, label, onDelete, children }) => (
//   <Box
//     mb={2}
//     p={2}
//     sx={{
//       border: "1px solid rgba(255,255,255,0.1)",
//       borderRadius: "10px",
//       background: "rgba(255,255,255,0.03)",
//     }}
//   >
//     <Box
//       display="flex"
//       alignItems="center"
//       justifyContent="space-between"
//       mb={1.5}
//     >
//       <Typography variant="caption" color="text.secondary" fontWeight={600}>
//         {label} {index + 1}
//       </Typography>
//       <Tooltip title="Remove">
//         <IconButton size="small" onClick={onDelete} color="error">
//           <DeleteOutlineIcon fontSize="small" />
//         </IconButton>
//       </Tooltip>
//     </Box>
//     {children}
//   </Box>
// );

// export default ItemCard;

import React from "react";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";

/**
 * ItemCard
 *
 * Props:
 *  - index      {number}   card number (0-based)
 *  - label      {string}   section name e.g. "Feature"
 *  - onDelete   {fn}       called when delete icon clicked
 *  - onEdit     {fn}       (optional) called when edit icon clicked
 *  - children   {node}     form fields rendered inside
 */
const ItemCard = ({ index, label, onDelete, onEdit, children }) => (
  <Box
    mb={2}
    p={2}
    sx={{
      position: "relative",
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "10px",
      background: "rgba(255,255,255,0.02)",
      transition: "border-color 0.18s",
      "&:hover": {
        borderColor: "rgba(255,255,255,0.16)",
        "& .item-controls": { opacity: 1 },
      },
    }}
  >
    {/* Header row */}
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb={1.5}
    >
      <Typography
        variant="caption"
        fontWeight={600}
        sx={{ color: "rgba(255,255,255,0.35)", textTransform: "uppercase", letterSpacing: "0.07em" }}
      >
        {label} {index + 1}
      </Typography>

      {/* Controls — visible on hover */}
      <Box
        className="item-controls"
        display="flex"
        gap={0.5}
        sx={{ opacity: 0, transition: "opacity 0.18s" }}
      >
        {onEdit && (
          <Tooltip title="Edit">
            <IconButton
              size="small"
              onClick={onEdit}
              sx={{
                width: 26,
                height: 26,
                borderRadius: "6px",
                background: "rgba(59,130,246,0.12)",
                color: "#3b82f6",
                "&:hover": { background: "rgba(59,130,246,0.22)" },
              }}
            >
              <EditIcon sx={{ fontSize: 13 }} />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title="Delete">
          <IconButton
            size="small"
            onClick={onDelete}
            sx={{
              width: 26,
              height: 26,
              borderRadius: "6px",
              background: "rgba(239,68,68,0.1)",
              color: "#ef4444",
              "&:hover": { background: "rgba(239,68,68,0.2)" },
            }}
          >
            <DeleteOutlineIcon sx={{ fontSize: 13 }} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>

    {children}
  </Box>
);

export default ItemCard;